import { useNavigate } from "react-router-dom";
import { useState } from "react";
import UserTopbar from "../../features/manageUsers/topbar";
import UserList from "../../features/manageUsers/userList";

const ManageUser = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isBlockedFilter, setIsBlockedFilter] = useState<boolean | undefined>(undefined);

  return (
    <>
      <div className="main_title">
        <h1>Manage Users</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
          - Manage Users
        </p>
      </div>
      <div className="cards">
        <UserTopbar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isBlockedFilter={isBlockedFilter}
          setIsBlockedFilter={setIsBlockedFilter}
        />
        <UserList searchTerm={searchTerm} isBlockedFilter={isBlockedFilter} />
      </div>
    </>
  );
};

export default ManageUser;
